import { Module } from 'vuex-smart-module';
import ProjectDetailsActions from './actions';
import ProjectDetailsGetters from './getters';
import ProjectDetailsMutations from './mutations';
import ProjectDetailsState from './state';

export default new Module({
  state: ProjectDetailsState,
  mutations: ProjectDetailsMutations,
  actions: ProjectDetailsActions,
  getters: ProjectDetailsGetters,
});
